import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "className", "label", "active", "icon", "proportional"];
import React from 'react';
import { Avatar, Text } from '@carnica/ui-kit';
import { forwardRefWithTag } from '@carnica/utils';
import { cnBem } from "../../../lib";
import styles from "./styles.pcss";
var cnContextMenuItem = cnBem('context-menu-item', styles);
export var ContextMenuItem = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'button' : _props$tagName,
    className = props.className,
    label = props.label,
    active = props.active,
    icon = props.icon,
    proportional = props.proportional,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnContextMenuItem({
      active: active,
      proportional: proportional
    }, [className]),
    ref: ref
  }, otherProps), icon && /*#__PURE__*/React.createElement(Avatar, {
    icon: icon
  }), /*#__PURE__*/React.createElement(Text, {
    align: "left",
    className: cnContextMenuItem('text'),
    variant: "body-small"
  }, label));
});